import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum TaskTimeDirectionId {
  BEFORE = 'before',
  AFTER = 'after',
}

export class TaskTimeDirection extends Codebook<TaskTimeDirectionId> {
  static readonly BEFORE = new TaskTimeDirection(TaskTimeDirectionId.BEFORE, () => $t('Before'))
  static readonly AFTER = new TaskTimeDirection(TaskTimeDirectionId.AFTER, () => $t('After'))

  private constructor(
    id: TaskTimeDirectionId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
